export const OPEN_CONTENT_LAYOUT = 'OPEN_CONTENT_LAYOUT';
export const CLOSE_CONTENT_LAYOUT = 'CLOSE_CONTENT_LAYOUT';
export const openContentLayout = value => ({ type: OPEN_CONTENT_LAYOUT, value });
export const closeContentLayout = value => ({ type: CLOSE_CONTENT_LAYOUT, value });
